// Multilingual content dictionary for Ristorante Grappolo d'Oro
// Languages: IT (default), EN, DE

export const translations = {
  it: {
    nav: {
      home: "Home",
      storia: "Storia",
      menu: "Menu",
      galleria: "Galleria",
      contatti: "Contatti",
      prenota: "Prenota",
    },
    hero: {
      eyebrow: "Dal 1952 — Monforte d'Alba",
      titleLine1: "Ristorante",
      titleLine2: "Grappolo",
      titleLine3: "d'Oro",
      subtitle:
        "Cucina, vino e ospitalità a Monforte d'Alba, dal 1952. Tre generazioni di una stessa famiglia, le ricette di nonna Vittoria e i grandi vini delle Langhe. Anche bar, dal mattino alla sera.",
      ctaReserve: "Prenota su WhatsApp",
      ctaCall: "Chiama ora",
      scroll: "Scorri",
    },
    marquee: "Dal 1952 · Cucina di Langa · Vini del Territorio · Monforte d'Alba",
    storia: {
      eyebrow: "La nostra storia",
      title: "Tre generazioni,\nun'unica passione.",
      p1:
        "Era il 1952 quando la famiglia aprì le porte del Grappolo d'Oro nel cuore di Monforte d'Alba. Da allora, nella stessa sala affacciata su Piazza Umberto I, continua la stessa storia: una cucina fatta con le mani, con il tempo, con il rispetto della terra.",
      p2:
        "Gli insegnamenti della signora Vittoria sono il nostro filo conduttore. Una ricetta non è mai soltanto una ricetta: è un paese, una stagione, un gesto tramandato. Oggi, come allora, scegliamo i produttori di Langa uno per uno e portiamo in tavola solo ciò di cui siamo fieri.",
      p3:
        "Oggi a portare avanti questa tradizione c'è Aurora: dopo oltre vent'anni di lavoro al Grappolo d'Oro — un luogo che l'ha vista crescere come professionista e come donna — ha deciso di prendere in mano il timone per continuare la tradizione di famiglia.",
      quote:
        "«Non cuciniamo per stupire. Cuciniamo perché vi sentiate a casa, in Langa.»",
      quoteAuthor: "La famiglia Grappolo d'Oro",
      auroraLabel: "La nuova gestione",
    },
    menu: {
      eyebrow: "La carta",
      title: "Menu",
      intro:
        "La carta cambia con la stagione, con il mercato, con il tempo. Qui la nostra proposta attuale. Per il menu del giorno, allergie o intolleranze, chiedete in sala. I numeri tra parentesi indicano gli allergeni di legge — chiedeteci la lista completa.",
      categories: [
        {
          key: "antipasti",
          title: "Antipasti",
          price: "€ 10",
          items: [
            { name: "Battuta di Fassona Piemontese", desc: "con salsa di soia e cugnà (8-12)" },
            { name: "Vitello Tonnato", desc: "cottura sotto sale (2-7-11)" },
            { name: "Insalatina tiepida di galletto", desc: "all'aceto balsamico (8-9)" },
            { name: "Uovo croccante", desc: "con crema di parmigiano e valeriana (1-3-11)" },
            { name: "Baccalà mantecato", desc: "con pesto di rucola (2-3-5)" },
            { name: "Prosciutto crudo e melone", desc: "" },
            { name: "Caprese", desc: "pomodori e mozzarella (3)" },
          ],
        },
        {
          key: "primi",
          title: "Primi",
          price: "€ 13",
          items: [
            { name: "Tajarin al ragù di salsiccia", desc: "(1-11-13)" },
            { name: "Ravioli del «Plin»", desc: "al sugo d'arrosto (1-11)" },
            { name: "Gnocchi pomodoro e basilico", desc: "(11)" },
            { name: "Risotto vegetariano", desc: "" },
            { name: "Spaghetti al ragù di polpo", desc: "e granella di pistacchio (1-2-8-14)" },
          ],
        },
        {
          key: "secondi",
          title: "Secondi",
          price: "€ 16",
          items: [
            { name: "Cappello del prete al Nebbiolo", desc: "spalla di vitello brasata al Nebbiolo (5-8-9)" },
            { name: "Filetto di maiale alle nocciole", desc: "(5-8)" },
            { name: "Rolata di coniglio al forno", desc: "" },
            { name: "Polpo spadellato", desc: "con purè di ceci (1-2-14)", price: "€ 18" },
          ],
        },
        {
          key: "dolci",
          title: "Dolci & Formaggi",
          price: "€ 6",
          items: [
            { name: "Panna cotta", desc: "con coulis di frutta (3)" },
            { name: "Semifreddo al torrone", desc: "con cioccolato caldo (3-8-11)" },
            { name: "Tiramisù", desc: "(3-8-11)" },
            { name: "Budino pesche e amaretti", desc: "(1-3-5-11)" },
            { name: "Misto di formaggi", desc: "con cugnà (3-5-8)", price: "€ 7" },
          ],
          footer: "Pane e coperto € 2,00.",
        },
      ],
    },
    galleria: {
      eyebrow: "Galleria",
      title: "Sguardi dalla sala\ne dalle colline.",
      intro: "Le Langhe, la nostra tavola, i gesti di ogni giorno.",
    },
    contatti: {
      eyebrow: "Contatti & Prenotazioni",
      title: "Vi aspettiamo\na tavola.",
      intro:
        "Per prenotare il vostro tavolo, scriveteci su WhatsApp o chiamateci direttamente. Rispondiamo personalmente.",
      reservationsLabel: "Prenotazioni",
      phoneLabel: "Cellulare",
      landlineLabel: "Fisso / Fax",
      emailLabel: "Email",
      addressLabel: "Indirizzo",
      hoursLabel: "Orari ristorante",
      hoursNote:
        "Il nostro ristorante è aperto tutti i giorni, eccetto il martedì, dalle 12:30 alle 15:00 con menù à la carte. Il servizio cena è disponibile in alcune serate su prenotazione. Vi consigliamo di contattare direttamente il ristorante per verificare disponibilità e apertura serale.",
      barLabel: "Bar",
      barValue: "Aperto 06:00 – 22:00 · Martedì chiuso — caffè, aperitivi, vini al calice",
      hoursValue: [
        "Pranzo · 12:30 – 15:00",
        "Martedì: giorno di riposo",
      ],
      whatsappCta: "Scrivici su WhatsApp",
      callCta: "Chiama il ristorante",
      mapsCta: "Apri in Google Maps",
      prefill:
        "Buongiorno, vorrei prenotare un tavolo al Ristorante Grappolo d'Oro. Siamo in __ persone per il giorno __ alle __ . Grazie!",
      form: {
        eyebrow: "Oppure scrivici",
        title: "Richiedi informazioni",
        intro:
          "Se preferisci l'email, compila il modulo: ti risponderemo al più presto.",
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono (facoltativo)",
        people: "Numero persone",
        date: "Data e orario",
        message: "Messaggio",
        messagePlaceholder: "Occasione, preferenze, allergie, note...",
        submit: "Invia richiesta",
        submitting: "Invio in corso...",
        successTitle: "Richiesta ricevuta",
        successBody: "Grazie! Ti ricontatteremo a breve.",
        errorTitle: "Qualcosa è andato storto",
        errorBody: "Riprova fra poco, oppure scrivici direttamente su WhatsApp.",
        required: "Campo obbligatorio",
        invalidEmail: "Email non valida",
        alsoWhatsapp: "Oppure invia il messaggio anche su WhatsApp",
      },
    },
    footer: {
      tagline: "Ristorante di Langa · Monforte d'Alba",
      since: "Dal 1952",
      rights: "Tutti i diritti riservati.",
      pIva: "P.IVA 03589860042",
    },
    holiday: {
      badge: "Avviso",
      title: "Siamo in ferie",
      dates: "dal 17 al 27 agosto",
      reopen: "Ci vediamo il 28/08",
      message:
        "Il ristorante e il bar restano chiusi per le ferie estive. Vi aspettiamo dopo il rientro con nuove proposte di stagione.",
      dismiss: "Ho capito",
      contact: "Per informazioni scriveteci su WhatsApp",
    },
  },
  en: {
    nav: {
      home: "Home",
      storia: "Our Story",
      menu: "Menu",
      galleria: "Gallery",
      contatti: "Contact",
      prenota: "Book",
    },
    hero: {
      eyebrow: "Since 1952 — Monforte d'Alba",
      titleLine1: "Ristorante",
      titleLine2: "Grappolo",
      titleLine3: "d'Oro",
      subtitle:
        "Cuisine, wine and hospitality in Monforte d'Alba, since 1952. Three generations of the same family, Nonna Vittoria's recipes and the great wines of the Langhe. Also a bar, from morning to night.",
      ctaReserve: "Book on WhatsApp",
      ctaCall: "Call us now",
      scroll: "Scroll",
    },
    marquee:
      "Since 1952 · Langhe Cuisine · Wines of the Territory · Monforte d'Alba",
    storia: {
      eyebrow: "Our story",
      title: "Three generations,\none passion.",
      p1:
        "It was 1952 when our family first opened the doors of Grappolo d'Oro in the heart of Monforte d'Alba. Since then, in the very same dining room overlooking Piazza Umberto I, the same story continues: food cooked by hand, with time, in respect of the land.",
      p2:
        "The teachings of Nonna Vittoria are our compass. A recipe is never just a recipe — it is a village, a season, a gesture handed down. Today, as then, we choose our Langhe producers one by one, and we serve only what we are proud of.",
      p3:
        "Today the tradition lives on through Aurora: after more than twenty years of work at Grappolo d'Oro — a place that watched her grow both as a professional and as a woman — she has decided to take the helm and carry on the family tradition.",
      quote:
        "\u201CWe don't cook to impress. We cook so that you feel at home, in Langa.\u201D",
      quoteAuthor: "The Grappolo d'Oro family",
      auroraLabel: "The new management",
    },
    menu: {
      eyebrow: "The menu",
      title: "Menu",
      intro:
        "Our menu changes with the season, the market and the hour. Here is our current selection. Please ask us for today's specials, allergies or intolerances. Numbers in parentheses indicate the legally required allergens — ask us for the full list.",
      categories: [
        {
          key: "antipasti",
          title: "Starters",
          price: "€ 10",
          items: [
            { name: "Piedmont Fassona beef tartare", desc: "with soy sauce and cugnà (8-12)" },
            { name: "Vitello Tonnato", desc: "salt-crust cooked veal with tuna sauce (2-7-11)" },
            { name: "Warm cockerel salad", desc: "with balsamic vinegar (8-9)" },
            { name: "Crispy egg", desc: "parmesan cream and lamb's lettuce (1-3-11)" },
            { name: "Creamed cod", desc: "with arugula pesto (2-3-5)" },
            { name: "Prosciutto and melon", desc: "" },
            { name: "Caprese", desc: "tomatoes and mozzarella (3)" },
          ],
        },
        {
          key: "primi",
          title: "First Courses",
          price: "€ 13",
          items: [
            { name: "Tajarin with sausage ragù", desc: "(1-11-13)" },
            { name: "Ravioli «Plin»", desc: "with roast jus (1-11)" },
            { name: "Gnocchi with tomato and basil", desc: "(11)" },
            { name: "Vegetarian risotto", desc: "" },
            { name: "Spaghetti with octopus ragù", desc: "and chopped pistachios (1-2-8-14)" },
          ],
        },
        {
          key: "secondi",
          title: "Main Courses",
          price: "€ 16",
          items: [
            { name: "Cappello del prete in Nebbiolo", desc: "veal shoulder braised in Nebbiolo wine (5-8-9)" },
            { name: "Pork fillet with hazelnuts", desc: "(5-8)" },
            { name: "Oven-roasted rabbit roll", desc: "" },
            { name: "Pan-fried octopus", desc: "with chickpea purée (1-2-14)", price: "€ 18" },
          ],
        },
        {
          key: "dolci",
          title: "Desserts & Cheese",
          price: "€ 6",
          items: [
            { name: "Panna cotta", desc: "with fruit coulis (3)" },
            { name: "Nougat semifreddo", desc: "with hot chocolate (3-8-11)" },
            { name: "Tiramisù", desc: "(3-8-11)" },
            { name: "Peach & amaretti pudding", desc: "(1-3-5-11)" },
            { name: "Cheese board", desc: "with cugnà (3-5-8)", price: "€ 7" },
          ],
          footer: "Bread & cover charge € 2.00.",
        },
      ],
    },
    galleria: {
      eyebrow: "Gallery",
      title: "Glimpses of our table\nand the hills.",
      intro: "The Langhe, our dining room, the everyday gestures.",
    },
    contatti: {
      eyebrow: "Contact & Reservations",
      title: "We look forward\nto having you.",
      intro:
        "To book your table, send us a WhatsApp or call us directly — we answer in person.",
      reservationsLabel: "Reservations",
      phoneLabel: "Mobile",
      landlineLabel: "Landline / Fax",
      emailLabel: "Email",
      addressLabel: "Address",
      hoursLabel: "Restaurant hours",
      hoursNote:
        "Our restaurant is open every day except Tuesday, from 12:30 to 3:00 pm, à la carte menu. Dinner service is available on selected evenings by reservation only. Please contact the restaurant directly to check availability and evening openings.",
      barLabel: "Bar",
      barValue: "Open 6:00 am – 10:00 pm · Closed on Tuesdays — coffee, aperitivo, wines by the glass",
      hoursValue: [
        "Lunch · 12:30 – 3:00 pm",
        "Tuesday: closed",
      ],
      whatsappCta: "Message us on WhatsApp",
      callCta: "Call the restaurant",
      mapsCta: "Open in Google Maps",
      prefill:
        "Hello, I would like to book a table at Ristorante Grappolo d'Oro. We are __ people for __ at __ . Thank you!",
      form: {
        eyebrow: "Or write to us",
        title: "Request information",
        intro:
          "If you prefer email, fill out the form and we'll get back to you soon.",
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        people: "Number of people",
        date: "Date & time",
        message: "Message",
        messagePlaceholder: "Occasion, preferences, allergies, notes...",
        submit: "Send request",
        submitting: "Sending...",
        successTitle: "Request received",
        successBody: "Thank you — we'll get back to you shortly.",
        errorTitle: "Something went wrong",
        errorBody: "Please try again, or write us directly on WhatsApp.",
        required: "Required field",
        invalidEmail: "Invalid email address",
        alsoWhatsapp: "Or also send your message on WhatsApp",
      },
    },
    footer: {
      tagline: "Langhe Restaurant · Monforte d'Alba",
      since: "Since 1952",
      rights: "All rights reserved.",
      pIva: "VAT 03589860042",
    },
    holiday: {
      badge: "Notice",
      title: "Closed for summer holidays",
      dates: "from 17 to 27 August",
      reopen: "See you on 28/08",
      message:
        "Our restaurant and bar are closed for summer holidays. We look forward to welcoming you back with new seasonal dishes.",
      dismiss: "Got it",
      contact: "For any questions, write us on WhatsApp",
    },
  },
  de: {
    nav: {
      home: "Home",
      storia: "Geschichte",
      menu: "Speisekarte",
      galleria: "Galerie",
      contatti: "Kontakt",
      prenota: "Reservieren",
    },
    hero: {
      eyebrow: "Seit 1952 — Monforte d'Alba",
      titleLine1: "Ristorante",
      titleLine2: "Grappolo",
      titleLine3: "d'Oro",
      subtitle:
        "Küche, Wein und Gastlichkeit in Monforte d'Alba, seit 1952. Drei Generationen derselben Familie, die Rezepte von Nonna Vittoria und die großen Weine der Langhe. Auch Bar — von morgens bis abends.",
      ctaReserve: "Auf WhatsApp reservieren",
      ctaCall: "Jetzt anrufen",
      scroll: "Scrollen",
    },
    marquee:
      "Seit 1952 · Küche der Langhe · Weine aus dem Piemont · Monforte d'Alba",
    storia: {
      eyebrow: "Unsere Geschichte",
      title: "Drei Generationen,\neine Leidenschaft.",
      p1:
        "Es war 1952, als unsere Familie die Türen des Grappolo d'Oro im Herzen von Monforte d'Alba öffnete. Seitdem geht im selben Saal mit Blick auf die Piazza Umberto I dieselbe Geschichte weiter: eine Küche von Hand, mit Zeit, aus Respekt vor dem Land.",
      p2:
        "Die Lehren von Nonna Vittoria sind unser roter Faden. Ein Rezept ist nie nur ein Rezept — es ist ein Dorf, eine Jahreszeit, eine weitergegebene Geste. Noch heute wählen wir unsere Erzeuger aus den Langhe einzeln aus und bringen nur auf den Tisch, worauf wir stolz sind.",
      p3:
        "Heute trägt Aurora diese Tradition weiter: Nach über zwanzig Jahren Arbeit im Grappolo d'Oro — einem Ort, der sie sowohl beruflich als auch persönlich hat wachsen sehen — hat sie sich entschieden, das Ruder zu übernehmen und die Familientradition fortzuführen.",
      quote:
        "\u201EWir kochen nicht, um zu beeindrucken. Wir kochen, damit Sie sich zuhause fühlen — in Langa.\u201C",
      quoteAuthor: "Die Familie Grappolo d'Oro",
      auroraLabel: "Die neue Leitung",
    },
    menu: {
      eyebrow: "Die Karte",
      title: "Menu",
      intro:
        "Unsere Karte ändert sich mit der Saison, dem Markt und der Stunde. Hier unsere aktuelle Auswahl. Tagesempfehlungen, Allergien oder Unverträglichkeiten fragen Sie gern im Saal. Die Zahlen in Klammern sind die gesetzlich vorgeschriebenen Allergene — fragen Sie uns nach der vollständigen Liste.",
      categories: [
        {
          key: "antipasti",
          title: "Vorspeisen",
          items: [
            { name: "Tatar vom piemontesischen Fassona-Rind", desc: "mit Sojasauce und Cugnà (8-12)" },
            { name: "Vitello Tonnato", desc: "in Salzkruste gegartes Kalbfleisch mit Thunfischsauce (2-7-11)" },
            { name: "Lauwarmer Hähnchensalat", desc: "mit Balsamico (8-9)" },
            { name: "Knuspriges Ei", desc: "mit Parmesan-Creme und Feldsalat (1-3-11)" },
            { name: "Stockfisch-Creme", desc: "mit Rucola-Pesto (2-3-5)" },
            { name: "Rohschinken und Melone", desc: "" },
            { name: "Caprese", desc: "Tomaten und Mozzarella (3)" },
          ],
        },
        {
          key: "primi",
          title: "Erste Gänge",
          items: [
            { name: "Tajarin mit Salsiccia-Ragù", desc: "(1-11-13)" },
            { name: "Ravioli «Plin»", desc: "mit Bratensauce (1-11)" },
            { name: "Gnocchi mit Tomate und Basilikum", desc: "(11)" },
            { name: "Vegetarisches Risotto", desc: "" },
            { name: "Spaghetti mit Oktopus-Ragù", desc: "und gehackten Pistazien (1-2-8-14)" },
          ],
        },
        {
          key: "secondi",
          title: "Hauptgänge",
          items: [
            { name: "Cappello del prete im Nebbiolo", desc: "Kalbsschulter im Nebbiolo geschmort (5-8-9)" },
            { name: "Schweinefilet mit Haselnüssen", desc: "(5-8)" },
            { name: "Kaninchenrolle aus dem Ofen", desc: "" },
            { name: "Gebratener Oktopus", desc: "auf Kichererbsenpüree (1-2-14)" },
          ],
        },
        {
          key: "dolci",
          title: "Desserts",
          items: [
            { name: "Panna cotta", desc: "mit Fruchtcoulis (3)" },
            { name: "Nougat-Semifreddo", desc: "mit heißer Schokolade (3-8-11)" },
            { name: "Tiramisù", desc: "(3-8-11)" },
            { name: "Pfirsich-Amaretti-Pudding", desc: "(1-3-5-11)" },
            { name: "Käseplatte", desc: "mit Cugnà (3-5-8)" },
          ],
          footer: "Brot & Gedeck € 2,00.",
        },
      ],
    },
    galleria: {
      eyebrow: "Galerie",
      title: "Einblicke in unseren Saal\nund in die Hügel.",
      intro: "Die Langhe, unser Tisch, die tägliche Arbeit.",
    },
    contatti: {
      eyebrow: "Kontakt & Reservierungen",
      title: "Wir erwarten Sie\nan der Tafel.",
      intro:
        "Für Ihre Tischreservierung schreiben Sie uns auf WhatsApp oder rufen Sie uns direkt an — wir antworten persönlich.",
      reservationsLabel: "Reservierungen",
      phoneLabel: "Mobil",
      landlineLabel: "Festnetz / Fax",
      emailLabel: "E-Mail",
      addressLabel: "Adresse",
      hoursLabel: "Restaurant-Öffnungszeiten",
      hoursNote:
        "Unser Restaurant ist täglich außer dienstags von 12:30 bis 15:00 Uhr mit À-la-carte-Menü geöffnet. Der Abendservice ist an ausgewählten Abenden nur auf Reservierung verfügbar. Bitte kontaktieren Sie uns direkt, um Verfügbarkeit und Abendöffnung zu prüfen.",
      barLabel: "Bar",
      barValue: "Geöffnet 06:00 – 22:00 Uhr · Dienstag Ruhetag — Kaffee, Aperitif, offene Weine",
      hoursValue: [
        "Mittagessen · 12:30 – 15:00 Uhr",
        "Dienstag: Ruhetag",
      ],
      whatsappCta: "Schreiben Sie uns auf WhatsApp",
      callCta: "Restaurant anrufen",
      mapsCta: "In Google Maps öffnen",
      prefill:
        "Guten Tag, ich möchte einen Tisch im Ristorante Grappolo d'Oro reservieren. Wir sind __ Personen am __ um __ . Vielen Dank!",
      form: {
        eyebrow: "Oder schreiben Sie uns",
        title: "Informationen anfragen",
        intro:
          "Wenn Sie E-Mail bevorzugen, füllen Sie das Formular aus — wir melden uns zeitnah.",
        name: "Name und Nachname",
        email: "E-Mail",
        phone: "Telefon (optional)",
        people: "Anzahl der Personen",
        date: "Datum & Uhrzeit",
        message: "Nachricht",
        messagePlaceholder: "Anlass, Vorlieben, Allergien, Hinweise...",
        submit: "Anfrage senden",
        submitting: "Wird gesendet...",
        successTitle: "Anfrage erhalten",
        successBody: "Vielen Dank — wir melden uns in Kürze bei Ihnen.",
        errorTitle: "Etwas ist schiefgelaufen",
        errorBody: "Bitte versuchen Sie es erneut oder schreiben Sie uns direkt auf WhatsApp.",
        required: "Pflichtfeld",
        invalidEmail: "Ungültige E-Mail-Adresse",
        alsoWhatsapp: "Oder senden Sie Ihre Nachricht auch per WhatsApp",
      },
    },
    footer: {
      tagline: "Langhe-Restaurant · Monforte d'Alba",
      since: "Seit 1952",
      rights: "Alle Rechte vorbehalten.",
      pIva: "USt-IdNr. 03589860042",
    },
    holiday: {
      badge: "Mitteilung",
      title: "Sommerurlaub",
      dates: "vom 17. bis 27. August geschlossen",
      reopen: "Wir sehen uns am 28.08.",
      message:
        "Das Restaurant und die Bar bleiben für den Sommerurlaub geschlossen. Wir freuen uns, Sie danach mit neuen saisonalen Vorschlägen begrüßen zu dürfen.",
      dismiss: "Verstanden",
      contact: "Für Fragen schreiben Sie uns auf WhatsApp",
    },
  },
};

export const LANG_CODES = ["it", "en", "de"];
export const LANG_LABELS = { it: "IT", en: "EN", de: "DE" };
